import React, { useEffect, useState } from 'react'
import { postPDFDescripcionQx, postPDFNotaQx } from '../../../../services/PaginaRuta'
import PDFNotaQx from './PDFNotaQx'
import {PDFDownloadLink} from '@react-pdf/renderer'
import PDFDescripcionQuirurgica from '../PDFDescripcionQuirurgica'

const ModalImprimirPDFEspecialistas = ({setmodalOnImprimir, user, dataInstrumentador, dataAnestesiologo}) => {
    const [dataProcedimientos, setDataProcedimientos] = useState([])
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      const [seleccionarMedico, setseleccionarMedico]=useState({})
        const [dataDescripcionQx, setdataDescripcionQx]=useState({
            "MCDpto": "",
            "EMPCOD": "",
            "MCDnom": "",
            "EmpNit": "",
            "EmpRazSoc": "",
            "EmpLogo": "",
            "MCDptCod": "",
            "MCCiuCod": "",
            "MDCodM": "",
            "MDCodD": "",
            "MDNomD": "",
            "MDNomM": "",
            "ProCirCod": "",
            "ProHorI": "",
            "MPCedu": "",
            "MPTDoc": "",
            "MPNOMC": "",
            "ProCons": "",
            "ProNcons": "",
            "ProFec": "",
            "PosTpHerd": "",
            "ProNEPS": "",
            "MPFchN": "",
            "ProSit": "",
            "ProFliSol": "",
            "ProCtvIn": "",
            "ProEPS": "",
            "MESITRIA": "",
            "PrcMulOpc": "",
            "PrcMulTip": "",
            "MTUCod": "",
            "MTCodP": "",
            "MENNIT": "",
            "MTNomP": "",
            "MTUDes": "",
            "TFcCodPab": "",
            "TFcCodCam": "",
            "ClaPro": "",
            "MPCodP": "",
            "MPNomP": "",
            "ViaCod": "",
            "MedCod": "",
            "EspcCod": "",
            "MedNom": "",
            "CrgEst": "",
            "CrgDes": "",
            "CrgCnt": "",
            "ViaDsc": "",
            "EspcDes": "",
            "CrgCod": "",
            "MTUCo1": "",
            "PTCodi": "",
            "MEPPVig": "",
            "PTApMo": "",
            "ForLiqCod": "",
            "TrfCod": "",
            "PTRecarg": "",
            "HomProCnt": "",
            "HomProLH": "",
            "HomProVlr": "",
            "HorIniCir": "",
            "HorFinCir": "",
            "DiaEnt": "",
            "DiaSal": "",
            "TipHer": "",
            "CanSan": "",
            "TiePer": "",
            "TieClamp": "",
            "ViaIng": "",
            "EstCir": "",
            "TipAne": "",
            "CscIng": "",
            "DQxCod": "",
            "DesCir": "",
            "DesCom": "",
            "CodEsp": "",
            "DesDatMUn": "",
            "DesInNNIS": "",
            "DesIndCom": "",
            "FECINICIR": "",
            "TpAnsCod": "",
            "TpAnsDsc": "",
            "CodMed2":"",
            "CodEsp2":"",
            "DiligencioFormularioCirujanoUno":"",
            "DiligencioFormularioCirujanoDos":"",
            "DesHalEnc2":"",
            "DesCir2":""
    
    
        })
        const [dataOtrosParticipantes, setdataOtrosParticipantes]=useState([])
        const [dataPreoperatorio, setdataPreoperatorio]=useState([])
        const [dataPostOperatorio,setdataPostOperatorio]=useState([])
        const [dataProcedimientosQx, setdataProcedimientosQx]=useState([])
        const [loading, setloading]=useState(false)
        const [dataDescripcionQxCirujanos, setdataDescripcionQxCirujanos]=useState([])
        

    const handleCancelarClick=()=>{
        setmodalOnImprimir(false)
    }

    useEffect(() => {
        console.log(dataInstrumentador,' dataInstrumentador')
        const dataPDF={
                    'ProCirCod' : user.ProCirCod,
                    'MCDpto' : user.ProMCDpto,
                    'EMPCOD' : user.ProEmpCod,
                    'ProEPS' : user.ProEPS,
                  }
                  //setLoading(false)
                  postPDFNotaQx(dataPDF).then((res)=>{
                    //setLoading(true)
                    console.log(res.data,' dataPDF')
                    setDataProcedimientos(res.data)
                  })
    }, [])

    useEffect(()=>{
            setloading(false)
    
            let cantidadCirujanos= 1
          if(user.ProPerSe1 && user.ProPerSe2){
            cantidadCirujanos= 2
          }
          setseleccionarMedico({
            cantidadCirujanos
          })
            const dataParaDescripcionQx={
                "EMPCOD":usuarioInfo.Empresa,
                "MCDpto":usuarioInfo.Sede,
                "MDCodM":"1",
                "ProCirCod":user.ProCirCod
              }
              //console.log(item,'itemmmm')
          postPDFDescripcionQx(dataParaDescripcionQx).then((res)=>{
            setloading(true)
            if(res.data.error){
              //console.log('Error')
    
            }else{
              //console.log(res.data,'data pdf descripcion qx')
              //console.log(res.data.DatosEmpresaAndUser[0],'data pdf descripcion qx DatosEmpresaAndUser')
              setdataDescripcionQx(res.data.DatosEmpresaAndUser[0])
              setdataOtrosParticipantes(res.data.otrosAyudantes)
              setdataPreoperatorio(res.data.otrosDoloresEntrada)
              setdataPostOperatorio(res.data.otrosDoloresSalida)
              setdataProcedimientosQx(res.data.variosProcedimientosUVR)
              setdataDescripcionQxCirujanos(res.data.descripcionQxCirujanos)
            }
            
          
          })
        },[])
    
    
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-2xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
                Imprimir PDF Especialistas
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            
              
            
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-4 inline-block min-w-full">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center bg-gray-200">
                      <thead className="">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900"
                          >
                            
                          </th>
                        
                          
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Descripción
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            
                          </th>
                        </tr>
                      </thead>
                      <tbody>
      <tr className=" divide-y divide-slate-700 ">
        <td></td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          Instrumentador Quirúrgico
        </td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
        <PDFDownloadLink document={<PDFNotaQx dataProcedimientos={dataProcedimientos} user={user} dataAnestesiologo={dataInstrumentador} textNota={dataInstrumentador.nota?dataInstrumentador.nota:'' }/>} fileName='pdfffffffffffffff.pdf'>
        <button
                // onClick={handleOnclickListaChequeo}
                type="button"
                className="relative inline-block px-1 py-0.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out group"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth="1.5" 
                  stroke="currentColor" 
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
                </svg>

                
              </button>
              </PDFDownloadLink>
        </td>
      </tr>      
      <tr className=" divide-y divide-slate-700 ">
        <td></td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          Anestesiólogo
        </td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
        <PDFDownloadLink document={<PDFNotaQx dataProcedimientos={dataProcedimientos} user={user} dataAnestesiologo={dataAnestesiologo} textNota={dataAnestesiologo.nota?dataAnestesiologo.nota:''}/>} fileName='pdffffffffffffffffffffffff.pdf'>
        <button
                // onClick={handleOnclickListaChequeo}
                type="button"
                className="relative inline-block px-1 py-0.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out group"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth="1.5" 
                  stroke="currentColor" 
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
                </svg>

                
              </button>
              </PDFDownloadLink>
        </td>
      </tr>      
      <tr className=" divide-y divide-slate-700 ">
        <td></td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          Descripción Quirúrgica
        </td>
        
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
        <PDFDownloadLink document={<PDFDescripcionQuirurgica dataDescripcionQx={dataDescripcionQx} dataOtrosParticipantes={dataOtrosParticipantes} dataPostOperatorio={dataPostOperatorio} dataPreoperatorio={dataPreoperatorio} dataProcedimientosQx={dataProcedimientosQx} seleccionarMedico={seleccionarMedico} dataDescripcionQxCirujanos={dataDescripcionQxCirujanos}/>} fileName="DescripcionQXXllllllllllll.pdf">
        <button
                // onClick={handleOnclickListaChequeo}
                type="button"
                className="relative inline-block px-1 py-0.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out group"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth="1.5" 
                  stroke="currentColor" 
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
                </svg>

                
              </button>
              </PDFDownloadLink>
        </td>
      </tr>      
    </tbody>
                       
                      
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            
          </div>
        </div>
      </div>
      {
            loading? 
            null:
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
        
          }    
    </div>
  )
}

export default ModalImprimirPDFEspecialistas